import React, { useContext, useState } from 'react';
import { styled } from '../components/styled';
import SpText from '../components/atoms/SpText';
import { theme } from '../components/theme';
import { Grid } from '@material-ui/core';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import SpLoadingButton from '../components/atoms/SpLoadingButton';
import { logo_url_dev } from '../config';
import { createDeleteRequests } from '../models/actions/DeleteRequests';
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { googleLogout } from '@react-oauth/google';
import { UserSessionContext } from '../App';
import SpIconAndTextButton from '../components/atoms/SpIconAndTextButton';
import { logoutUser } from '../models/actions/Auth';
import { ExitToApp } from '@mui/icons-material';

const StyledColumnLogin = styled(Grid)({
  alignSelf: 'center',
  padding: '2%',
  marginTop: 50,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '40%',
  border: '1px solid #4DAC27',
  borderRadius: 20,
  color: '#4DAC27',
  borderColor: '#4DAC27',
  backgroundColor: '#FFF',
  boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `
});

const CompleteUserDelete = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);
  const userData = location.state?.data;

  const confirmDeleteRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await createDeleteRequests({ email_user: userData?.userEmail, id_user: userData?.idUser && '', request_accepted: false, request_date: new Date() }, authData?.accessToken);
      if (response.message) {
        googleLogout();
        setAuthData({ accessToken: null, userId: null });
        history.push({ pathname: '/users-delete/login', state: { from: null, data: null } });
      }
    } catch (err) {
      props.snackbarShowErrorMessage(err);
    }
    setIsLoading(false);
  };

  const logout = async () => {
    try {
      googleLogout();
      const response = await logoutUser({ id: authData.userId }, authData.accessToken);
      if (response) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userId');
        setAuthData({ accessToken: null, userId: null });
        return history.replace('/users-delete/login');
      } else {
        props.snackbarShowErrorMessage(response.error);
      }
    } catch (err) {
      props.snackbarShowErrorMessage(err);
    }
  };

  return (
    <>
      <StyledColumnLogin
        container
        spacing={2}
        direction="column"
        alignItems="center"
      >
        <Grid
          item
          xs={10}
          style={{ width: '100%' }}
        >
          <img
            style={{ width: '100%' }}
            src={logo_url_dev}
          />
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpText>Confermando la richiesta tutti i tuoi dati che hai fornito all'applicazione verrano eliminati dalla piattaforma entro 90 giorni. Asobike dovrà controllare che tutti i tuoi noleggi siano stati chiusi correttamente.</SpText>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpLoadingButton
            loading={isLoading}
            style={{ marginTop: '3%', marginRight: '0 !important' }}
            text={'CONFERMA ELIMINIAZIONE'}
            onClick={(e) => confirmDeleteRequest(e)}
            variant="none"
          />
        </Grid>
        <Grid
          item
          xs={8}
        >
          <SpLoadingButton
            loading={isLoading}
            style={{ marginTop: '3%', marginRight: '0 !important' }}
            text={'LOGOUT'}
            onClick={() => logout()}
            variant="none"
          />
        </Grid>
      </StyledColumnLogin>
    </>
  );
};

export default withSnackbar(CompleteUserDelete);
